import { render } from "./AdminBacklog.vue?vue&type=template&id=b2156a1c"
import script from "./AdminBacklog.vue?vue&type=script&lang=js"
export * from "./AdminBacklog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__